import React from "react";
import { Modal, ModalBody } from "reactstrap";
import "../../assets/styles/deletePopup.css";

const VideoModal = ({ isOpen, onClose, attachment }) => {
  return (
    <Modal isOpen={isOpen} toggle={onClose} centered className="image-modal">
      <ModalBody>
        {attachment ? (
          <video
            controls
            style={{ width: "100%", maxHeight: "80vh" }}
            src={attachment}
          >
            Your browser does not support the video tag.
          </video>
        ) : (
          <p>No video available.</p>
        )}
      </ModalBody>
    </Modal>
  );
};

export default VideoModal;
